"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Price.scss");
var Price = function Price(_ref) {
  var labels = _ref.labels,
    price = _ref.price,
    isCustomerPrice = _ref.isCustomerPrice,
    elementLocator = _ref.elementLocator;
  return _react.default.createElement("div", {
    className: "price-container",
    "data-locator": "price-container"
  }, _react.default.createElement("span", {
    className: isCustomerPrice ? 'customer-price-label' : 'price-label',
    "data-locator": "price-label"
  }, labels), _react.default.createElement("div", {
    className: "cmp-sku__price",
    "data-locator": elementLocator || "price"
  }, price || ''));
};
Price.defaultProps = {
  labels: '',
  price: '',
  elementLocator: '',
  isCustomerPrice: false
};
var _default = Price;
exports.default = _default;
module.exports = exports["default"];